import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import { connect } from 'react-redux';
import { ROLE_RENTER, ROLE_USER } from '../../constants/roles';

export class SiteTableHead extends Component {
  state = {
    role: ROLE_USER,
  };

  static getDerivedStateFromProps(props) {
    let newState = null;
    if (props.authUser && props.roles) {
      const role = props.roles[props.authUser.uid];
      newState = {
        ...newState,
        role,
      };
    }
    return newState;
  }

  createSortHandler = property => (event) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {
      order,
      orderBy,
    } = this.props;

    const columnData = [
      {
        id: 'number',
        numeric: true,
        disablePadding: false,
        label: 'Numéro',
      },
      {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'Nom',
      },
      {
        id: 'renterName',
        numeric: false,
        disablePadding: false,
        label: 'Loueur',
      },
      {
        id: 'nb_bike_available',
        numeric: false,
        disablePadding: false,
        label: 'Vélos',
      },
      {
        id: 'radius',
        numeric: false,
        disablePadding: false,
        label: 'Rayon',
      },
      {
        id: 'turnover',
        numeric: false,
        disablePadding: false,
        label: 'CA',
      },
      {
        id: 'is_trace_direct',
        numeric: false,
        disablePadding: true,
        label: 'Trace Directe',
      },
      {
        id: 'is_bookable',
        numeric: false,
        disablePadding: true,
        label: 'Réservable',
      },
      {
        id: 'state',
        numeric: false,
        disablePadding: false,
        label: 'État',
      },
    ];

    if (this.state.role === ROLE_RENTER) {
      columnData.splice(columnData.findIndex(column => column.id === 'renterName'), 1);
    }

    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => (
            <TableCell
              key={column.id}
              numeric={column.numeric}
              padding={column.disablePadding
                ? 'none'
                : 'normal'}
            >
              <Tooltip
                title="Trier"
                placement={column.numeric
                  ? 'bottom-end'
                  : 'bottom-start'}
                enterDelay={300}
              >
                <TableSortLabel
                  active={orderBy === column.id}
                  direction={order === 'asc'
                    ? 'desc'
                    : 'asc'}
                  onClick={this.createSortHandler(column.id)}
                >
                  {column.label}
                </TableSortLabel>
              </Tooltip>
            </TableCell>
          ), this)}
          <TableCell padding="checkbox">
          </TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
    );
  }
}

SiteTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
  };
}

export default connect(mapStateToProps)(SiteTableHead);



// WEBPACK FOOTER //
// ./src/components/Site/SiteTableHead.jsx